"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Footer({ bgColor, subheading, website }) {
  const pathname = usePathname();

  const handleClick = async (hash) => {
    const element = document.getElementById(hash);
    if (element) {
      const offset = 50;

      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const targetPosition = elementPosition - offset;

      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    }
  };

  return (
    <footer
      className={`${pathname === "/extension/cancel" || pathname === "/extension/success" || pathname === "/signin" || pathname === "/signup" || pathname === "/credentials" ? "hidden" : ""}`}
    >
      <div className={`${bgColor} py-12 md:py-16`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 md:py-20 border-t border-gray-300">
          {/* Top area: Blocks */}
          <div className="grid md:grid-cols-12 gap-8 lg:gap-20 mb-8 md:mb-12">
            {/* 1st block */}
            <div className="md:col-span-4 lg:col-span-5">
              <div className="mb-2">
                {/* Logo */}
                <Link
                  href="/"
                  className="flex items-center z-10"
                  aria-label="Cruip"
                >
                  <Image
                    className="w-8"
                    width={500}
                    height={500}
                    src="/images/product/logo.webp"
                    alt="Website logo"
                  />
                  <p className="pl-2 text-xl text-primary font-semibold">
                    <span className="text-white">Notify</span>API
                  </p>
                </Link>
              </div>
              <div className="text-white mb-4">{subheading}</div>
            </div>

            {/* 2nd, 3rd and 4th blocks */}
            <div className="md:col-span-8 lg:col-span-7 grid sm:grid-cols-3 gap-8">
              {/* 2nd block */}
              <div className="text-sm">
                <p className="text-primary font-medium mb-2">Navigation</p>
                <ul className="flex flex-col gap-y-2">
                  <li>
                    <Link
                      href="/#features"
                      className="text-gray-200 hover:text-white transition duration-150 ease-in-out"
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/blog"
                      className="text-gray-200 hover:text-white transition duration-150 ease-in-out"
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/#faq"
                      className="text-gray-200 hover:text-white transition duration-150 ease-in-out"
                    >
                      FAQ
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom area */}
          <div className="md:flex md:items-center md:justify-between">
            {/* Copyrights note */}
            <div className="text-white text-sm mr-4">
              {/* &copy; {website}. All rights reserved. */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
